import BSWholeWheatEnglishMuffinsProduct from 'models/BSWholeWheatEnglishMuffinsProduct'

export const packagingInitialState = {
  category: BSWholeWheatEnglishMuffinsProduct.category,
  subCategory: BSWholeWheatEnglishMuffinsProduct.subCategory,
  Size: BSWholeWheatEnglishMuffinsProduct.Size,
}
